// @flow

import type { Store } from "redux";

export const PERSIST_KEY = "user";

const extractTokenFromStorage = (storage: Storage, persistKey: string) => {
  const persistence = storage.getItem(`persist:${persistKey}`);

  if (persistence) {
    const user = JSON.parse(persistence);
    if (user.token) {
      return JSON.parse(user.token);
    }
  }

  return null;
};

const extractTokenFromStore = (store: Store<any, any>) => {
  const state = store.getState();
  return state.user.token;
};

// eslint-disable-next-line import/prefer-default-export
export const getAuthToken = (store: Store<any, any>, persistKey = PERSIST_KEY) =>
  extractTokenFromStorage(sessionStorage, persistKey) ||
  extractTokenFromStorage(localStorage, persistKey) ||
  extractTokenFromStore(store) ||
  null;
